import {
    type ApiResult,
    type BaseParams,
    type ContinuationResult,
    links,
    type OwnershipCount,
    Request,
} from '@app/client';

import { apiReturnPaginatedResults } from '../../../../ApiFactory';

export const getCollectionOwnerCount = (params: BaseParams): Promise<ApiResult<OwnershipCount>> => {
    return Request.getRequest<OwnershipCount>({
        ...params,
        target: links.daas().v2.ownership.collection,
        apiSettingsType: 'daasV2',
    });
};
export const callGetCollectionOwnership = (params: BaseParams) =>
    apiReturnPaginatedResults<OwnershipCount, ContinuationResult<OwnershipCount>>(
        getCollectionOwnerCount,
        params,
        true,
    );
